import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import CustomButton from "../kits/button/CustomButton.jsx";
import { ReactSelect, CustomInput } from "../kits/Inputs/Inputs.tsx";
import DatePiker from "../datepiker/datePiker.jsx";

import useAxios from "../../services/useAxios.tsx";
export default function FilterStorageModal({
  users,
  filter,
  removeFilter,
  filterData,
  setFilterData,
  filterModalShow,
  setFilterModalShow,
  setInputData
}) {
  const { execute: findProduct } = useAxios("api2/Find_ProductServices");
  // const { execute: storeHouse } = useAxios("api2/storehouse");
  // const { execute: findUsers } = useAxios("api2/Find_users");

  const [product, setProduct] = useState([]);
  // const [users, setUsers] = useState([]);

  useEffect(() => {
    findProduct({ condition: "main_type/in/1,2" }).then(data => {
      let arr1 = [];
      for (let i = 0; i < data.length; i++) {
        let object = {};
        object.label = data[i].title;
        object.value = data[i].id;
        arr1.push(object);
      }
      setProduct(arr1);
    });
    //   findUsers({ conditions: "type/=/1" }).then(data => {
    //     let arr2 = [];
    //     for (let i = 0; i < data.length; i++) {
    //       let object = {};
    //       object.label = data[i].fullname;
    //       object.value = data[i].id;
    //       arr2.push(object);
    //     }
    //     setUsers(arr2);
    //     console.log("users", users);
    //   });
  }, []);

  // const removeFilter = () => {
  //   storeHouse().then(data => {});
  // };
  return (
    <>
      <hr style={{ color: "#677788", textAlign: "center" }} />
      <div className="mt-4">
        <CustomButton
          color="warning"
          size="large"
          className="mx-3 "
          onClick={() => {
            setFilterModalShow(true);
            setInputData("");
          }}
        >
          فیلتر
        </CustomButton>
      </div>
      <Modal
        show={filterModalShow}
        onHide={() => {
          setFilterModalShow(false);
        }}
      >
        <Modal.Header closeButton>فیلتر</Modal.Header>
        <Modal.Body>
          <div>
            <div className="mt-3">
              <ReactSelect
                isMulti={true}
                title="انتخاب محصول"
                itemsList={product}
                inputValue={filterData.selectedProduct}
                onChangeFunc={e => {
                  setFilterData(prev => {
                    return { ...prev, selectedProduct: e };
                  });
                  console.log("flterDattaaaa,", filterData);
                }}
              />
            </div>
            <div className="mt-4">
              <ReactSelect
                isMulti={true}
                title="انتخاب کاربر"
                itemsList={users}
                inputValue={filterData.selectedUser}
                onChangeFunc={e => {
                  setFilterData(prev => {
                    return { ...prev, selectedUser: e };
                  });
                  // setSelectedUser(e);
                  // console.log(
                  //   "userssss",
                  //   selectedUser.map(val => val.value).join(",")
                  // );
                }}
              />
            </div>
            <div className="mt-4">
              <label
                style={{
                  color: "#677788",
                  fontSize: "0.75rem",
                  marginBottom: "0.5rem"
                }}
              >
                بازه تاریخ برای قبض های ورودی
              </label>
              <DatePiker
                type_calender={"jalali"}
                // location={"right"}
                width="100%"
                buttons={true}
                inputSize={"text"}
                mood="domain"
                value={filterData.dateIn * 1000}
                setValue={e => {
                  setFilterData(prev => {
                    return { ...prev, dateIn: e };
                  });
                }}
              ></DatePiker>
            </div>
            <div className="mt-4 w-100">
              <label
                style={{
                  color: "#677788",
                  fontSize: "0.75rem",
                  marginBottom: "0.5rem"
                }}
              >
                بازه تاریخ برای قبض های خروجی
              </label>
              <DatePiker
                type_calender={"persian"}
                // location={"right"}
                //   color={"purple"}
                //   bg={"bg-dark"}
                width="100%"
                buttons={true}
                inputSize={"text"}
                value={filterData.dateOut * 1000}
                mood="domain"
                setValue={e => {
                  console.log("date", e);
                  setFilterData(prev => {
                    return { ...prev, dateOut: e };
                  });
                }}
              ></DatePiker>
            </div>
            <div className="mt-4">
              <label
                style={{
                  color: "#677788",
                  fontSize: "0.75rem",
                  marginBottom: "0.5rem"
                }}
              >
                بازه موجودی
              </label>
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <CustomInput
                    type="text"
                    inputValue={filterData.inventory1}
                    onChangeFunc={e => {
                      setFilterData(prev => {
                        return { ...prev, inventory1: e.target.value };
                      });
                    }}
                  ></CustomInput>
                </div>
                <p className="px-3">تا</p>
                <div className="flex-grow-1">
                  <CustomInput
                    type="text"
                    inputValue={filterData.inventory2}
                    onChangeFunc={e => {
                      setFilterData(prev => {
                        return { ...prev, inventory2: e.target.value };
                      });
                    }}
                  ></CustomInput>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <CustomButton color="primary" onClick={removeFilter}>
            حذف فیلتر
          </CustomButton>
          <CustomButton color="warning" onClick={filter}>
            فیلتر
          </CustomButton>
        </Modal.Footer>
      </Modal>
    </>
  );
}
